import lightGreen from '@material-ui/core/colors/lightGreen'
import orange from '@material-ui/core/colors/orange'
import red from '@material-ui/core/colors/red'

export const styles = theme => ({
  highlightConfirmed: {
    backgroundColor: lightGreen['A100'],
  },

  highlightNoResponse: {
    backgroundColor: orange['A100'],
  },
  
  highlightNotPaid: {
    backgroundColor: red['A400'],
  },

  tableCell: { 
    paddingLeft: 6, 
    paddingRight: 6, 
    width: 30 
  }
})



// WEBPACK FOOTER //
// ./src/components/Bookings/components/BookingsTableRow/styles.js